import {gql} from '@apollo/client';
import {OV_RECOMMENDATION} from '../../../graphql/fragments';

export const FINALISE_RECOMMEND = gql`
  ${OV_RECOMMENDATION}
  mutation FinaliseOvrecommend($ovrecommendId: UUID!) {
    finaliseOvrecommend(ovrecommendId: $ovrecommendId) {
      ok
      errors
      ovrecommend {
        ...OVRecommendation
      }
    }
  }
`;
